module.exports = __webpack_public_path__ + "static/media/icon-bubble.ed184309.svg";